import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { useCountExposureElections } from '../../coverages/hooks';
import React from 'react';
import styled from 'styled-components';
import { Card } from '../../../components';
import { useCountVehicles } from '../hooks';

const CardWrapper = styled.div`
  box-shadow: ${props => (props.isActive ? `0px 3px 0px 0px ${props.theme.blue}` : '')};
  border-radius: 10px;
`;

export default function DashboardFilters() {
  const { activeVehicles, openViolations } = useCountExposureElections();
  const { vehiclesCount } = useCountVehicles({ electionStatus: 'ACTIVE' });

  return (
    <Row className="mb-3">
      <Col>
        <Link to="/coverages/pending-approvals" style={{ textDecoration: 'none' }}>
          <Card
            title={'Pending Approval'}
            name="pending-approval"
            tooltip="Insurance selections that need to be reviewed"
            className="flex-grow-1 flex-shrink-1"
          >
            <h1 className="mb-0">{openViolations}</h1>
          </Card>
        </Link>
      </Col>
      <Col>
        <CardWrapper>
          <Card
            title={'Vehicle Elections'}
            name="vehicleElections"
            tooltip="Number of active vehicle coverages"
            className="flex-grow-1 flex-shrink-1"
          >
            <h1 className="mb-0">{activeVehicles}</h1>
          </Card>
        </CardWrapper>
      </Col>
      <Col>
        <CardWrapper>
          <Card
            title={'Vehicles'}
            name="vehicles"
            tooltip="Number of vehicles with active elections"
            className="flex-grow-1 flex-shrink-1"
          >
            <h1 className="mb-0">{vehiclesCount}</h1>
          </Card>
        </CardWrapper>
      </Col>
    </Row>
  );
}
